import React, { useState, useEffect } from "react"
import * as Util from "../helpers/util.js"
import { WEB_URL } from "../settings.js";


export const Sheets = props => {
    const { onSheet, showToast } = props

    const [state, setState] = useState({
        sheets: [],
    })
    const { sheets } = state

    useEffect(() => {
        Util.fetch_js(`${WEB_URL}/api/sheet_gen/list`, {},
            js => {
                setState(prev => ({ ...prev, sheets: js.sheets }))
            },
            err => {
                showToast(`Failed to load sheets ${err}`)
            })
    }, [])

    return (
        <div className="px-4 sm:px-6 lg:px-8">
            <div className="sm:flex sm:items-center">
                <div className="sm:flex-auto">
                    <h1 className="text-base font-semibold text-gray-900">Sheets</h1>
                    <p className="mt-2 text-sm text-gray-700">
                        A list of all sheets.
                    </p>
                </div>
                <div className="mt-4 sm:ml-16 sm:mt-0 sm:flex-none">
                    <button
                        type="button"
                        onClick={() => onSheet(null)}
                        className="block rounded-md bg-indigo-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
                        Create sheet
                    </button>
                </div>
            </div>
            <div className="mt-8 flow-root">
                <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                    <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                        <div className="overflow-hidden shadow ring-1 ring-black/5 sm:rounded-lg">
                            <table className="min-w-full divide-y divide-gray-300">
                                <thead className="bg-gray-50">
                                <tr>
                                    <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">
                                        Name
                                    </th>
                                    <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                        Timestamp
                                    </th>
                                    <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-6">
                                        <span className="sr-only">Edit</span>
                                    </th>
                                </tr>
                                </thead>
                                <tbody className="divide-y divide-gray-200 bg-white">
                                {sheets.map((sheet, idx) => (
                                    <tr key={`sheet_row_${idx}`}>
                                        <td onClick={() => onSheet(sheet)} className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6 cursor-pointer">
                                            {sheet.replace('_', ' ').replace(/^\d+./, '')}
                                        </td>
                                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                            {Util.epochToDateTime( sheet.replace(/[.].*$/, '') * 100)}
                                        </td>
                                        <td className="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                                            <div className="text-indigo-600 hover:text-indigo-900"
                                                onClick={() => onSheet(sheet)}>
                                                Edit<span className="sr-only"></span>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}